import * as React from "react";
import { forwardRef } from "react";
const SvgGraph = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 80, height: 26, viewBox: "0 0 80 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 25C1 25 6.20364 16.2064 13 16.2064C19.7964 16.2064 19.0536 21.521 25.9941 21.521C32.9346 21.521 35.9412 1 45.8235 1C55.7059 1 57.8284 19.9549 66.1176 19.9549C72.5754 19.9549 74.227 13 79 13", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgGraph);
export default ForwardRef;
